/**
 * Design-Tokens, die JavaScript kennen muss.
 *
 * Farben, Formen und Bewegung leben in `index.css` (`@theme`). Hier steht nur,
 * was zur Laufzeit gesetzt wird — die Dialektpalette — und die Bewegungswerte,
 * die die Web Animations API braucht.
 */

/**
 * In `element.animate()` niemals CSS-Custom-Properties als `easing`: die Web
 * Animations API akzeptiert sie nicht und wirft, bevor der Rest des Handlers
 * läuft. Deshalb stehen die Kurven hier literal.
 */
export const MOTION = {
  emphasized: 'cubic-bezier(0.2, 0, 0, 1)',
  standard: 'cubic-bezier(0.3, 0, 0.2, 1)',
  dauerKurz: 220,
  dauerMittel: 420,
  dauerThemenwechsel: 620,
} as const

/** Zuordnung der Schriftrolle aus der Registry auf eine konkrete Familie. */
export const SCHRIFTFAMILIEN = {
  serif: "ui-serif, Georgia, 'Iowan Old Style', 'Times New Roman', serif",
  sans: "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  // Systeme bringen selten eine Slab-Serif mit; der Rückfall bleibt bewusst
  // eine Serife statt einer beliebigen Ersatzschrift.
  slab: "'Roboto Slab', Rockwell, ui-serif, Georgia, serif",
} as const

export type Schriftrolle = keyof typeof SCHRIFTFAMILIEN

export function bewegungReduziert(): boolean {
  return (
    typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}
